<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Gestion des campus">
        <v-row>
          <v-col cols="12" md="4">
            <router-link
              :to="{
                name: 'form-campus',
              }"
              tag="v-btn"
            >
              <v-icon title="Ajouter un campus">mdi-plus</v-icon>
              Ajouter un campus</router-link
            >
          </v-col>
        </v-row>
        <v-row v-if="listeCampus.length > 0">
          <v-col cols="12" md="6" offset="0" offset-md="3">
            <v-data-table
              :headers="headers"
              :items="listeCampus"
              disable-pagination
              hide-default-footer
              item-key="id"
              disable-sort
              class="elevation-1"
            >
              <template v-slot:[`item.action`]="{ item }">
                <router-link
                  :to="{
                    name: 'form-campus',
                    params: {
                      idCampus: item.id,
                    },
                  }"
                >
                  <v-icon class="mr-2" title="Éditer le campus" color="primary"
                    >mdi-pencil</v-icon
                  ></router-link
                >

                <ActionConfirmation
                  icone="mdi-delete"
                  title="Supprimer le campus"
                  @ok="deleteCampus(item.id)"
                ></ActionConfirmation>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import ActionConfirmation from "@/components/ActionConfirmation";

export default {
  name: "ListeCampus",
  components: { BaseBlock, ActionConfirmation },

  data() {
    return {
      headers: [
        {
          text: "Libellé",
          align: "left",
          value: "libelle",
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
        },
      ],
      listeCampus: [],
      loading: false,
    };
  },
  async created() {
    await this.getListeCampus();
  },
  methods: {
    async getListeCampus() {
      try {
        const listeCampus = await ApiCampusRepository.getListeCampus();
        this.listeCampus = listeCampus;
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
    async deleteCampus(id) {
      this.loading = true;
      try {
        await ApiCampusRepository.deleteCampus(id);
        await this.getListeCampus();
        this.$toast.success("Campus supprimé");
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
